<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">名称</div>
            <el-input v-model="add_Name" placeholder="请输入名称"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="add_sort" placeholder="请输入排序"></el-input>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',
      add_sort:'',

    }
  },
  methods: {
    init(){

      this.add_Name = '';
      this.add_sort = '';

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.add_Name === ''){
        this.$message("请输入名称");
        return;
      }
      if(this.add_sort === ''){
        this.$message("请输入排序");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityType/Add',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.add_Name,
          sort:this.add_sort,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


